import { useTranslation } from 'react-i18next';

const STEPS = ['step1', 'step2', 'step3', 'step4'];

export default function HowItWorks() {
  const { t } = useTranslation();
  return (
    <section id="how" className="border-b border-border bg-surface">
      <div className="mx-auto max-w-6xl px-4 py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold sm:text-4xl">{t('how.title')}</h2>
          <p className="mt-4 text-text-muted">{t('how.subtitle')}</p>
        </div>
        <div className="relative mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          <div
            aria-hidden
            className="pointer-events-none absolute inset-x-8 top-6 hidden h-px lg:block"
            style={{
              background:
                'linear-gradient(to right, transparent, color-mix(in srgb, var(--color-primary) 40%, transparent), transparent)',
            }}
          />
          {STEPS.map((key, i) => (
            <div
              key={key}
              className="relative rounded-2xl border border-border bg-bg p-6 transition duration-200 hover:-translate-y-1 hover:border-border-strong"
            >
              <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-primary to-primary-2 text-base font-bold text-primary-fg shadow-lg shadow-primary/25">
                {i + 1}
              </div>
              <h3 className="text-base font-semibold">{t(`how.${key}.title`)}</h3>
              <p className="mt-2 text-sm leading-relaxed text-text-muted">{t(`how.${key}.body`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
